import {
  GRID_DETAIL_PANEL_TOGGLE_FIELD,
  GridColumnVisibilityModel,
} from '../../grid'

export enum PatientSearchColumnKey {
  id = 'id',
  mrn = 'mrn',
  name = 'name',
  status = 'status',
  dischargeReason = 'dischargeReason',
  dateOfBirth = 'dateOfBirth',
  primaryPhone = 'primaryPhone',
  primaryEmail = 'primaryEmail',
  timeZone = 'timeZone',
  genderIdentity = 'genderIdentity',
  careTeam = 'careTeam',
  npctm = 'npctm',
  warnings = 'warnings',
  tags = 'tags',
  actions = 'actions',
  insurance = 'insurance',
  otherPayerInfo = 'otherPayerInfo',
  messages = 'messages',
  globalTracks = 'globalTracks',
  individualTracks = 'individualTracks',
  upcomingAppointments = 'upcomingAppointments',
  nextAppointment = 'nextAppointment',
  serviceType = 'serviceType',
  state = 'address.state',
  selfPay = 'selfPay',

  // Appointment Filters
  appointmentServiceType = 'appointmentServiceType',
  appointmentDescription = 'appointmentDescription',
  appointmentStatus = 'appointmentStatus',
  appointmentDate = 'appointmentDate',
  appointmentProvider = 'appointmentProvider',
}

export const UPCOMING_APPOINTMENTS_GROUP_PATH = 'upcomingAppointments'

export const defaultVisibleColumns = [
  PatientSearchColumnKey.name,
  PatientSearchColumnKey.mrn,
  PatientSearchColumnKey.careTeam,
  PatientSearchColumnKey.dateOfBirth,
  PatientSearchColumnKey.genderIdentity,
  PatientSearchColumnKey.primaryEmail,
  PatientSearchColumnKey.primaryPhone,
  PatientSearchColumnKey.status,
  PatientSearchColumnKey.actions,
  PatientSearchColumnKey.nextAppointment,
  PatientSearchColumnKey.messages
]

export const defaultColumnVisibilityModel: GridColumnVisibilityModel = {
  ...Object.fromEntries(
    Object.values(PatientSearchColumnKey).map((v) => [
      v,
      defaultVisibleColumns.includes(v),
    ]),
  ),
  [GRID_DETAIL_PANEL_TOGGLE_FIELD]: false,
}

export const filterGroups: {
  label: string
  fields: PatientSearchColumnKey[]
  groupField: string
}[] = [
  {
    label: 'Upcoming Appointments',
    fields: [
      PatientSearchColumnKey.appointmentServiceType,
      PatientSearchColumnKey.appointmentDescription,
      PatientSearchColumnKey.appointmentStatus,
      PatientSearchColumnKey.appointmentDate,
      PatientSearchColumnKey.appointmentProvider,
    ],
    groupField: UPCOMING_APPOINTMENTS_GROUP_PATH,
  },
]
